<style src="./ColumnItem.scss" lang="scss" scoped></style>
<template>
  <li class="column-item box">
    <div class="id">
      <span
        v-if="!!info.itemInfo.lot"
        class="labellot">{{ info.itemInfo.lot }}</span>
      <span class="labelitem">{{ info.itemInfo.number }}</span>
    </div>

    <div class="description">
      <div class="counts">
        <span
          class="stricttome"
          v-if="!!info.itemInfo.strictToME"
          title="Exclusivo para ME">
          ME
        </span>
        <span title="Quantidade">{{ info.itemInfo.quantity | DecimalNumber }}</strong></span>
        <span title="Fator" v-show="Number(info.itemInfo.factor) > 0"><small>X</small> <strong>{{ info.itemInfo.factor | DecimalNumber }}</strong></span>
        <span title="Preço estimado"><small>R$</small> <strong>{{ info.itemInfo.estimatedPrice | CurrencyBR }}</strong></span>
        <span title="Total" class="total"><small>R$</small> <strong>{{ (info.itemInfo.estimatedPrice || 0) * (info.itemInfo.quantity || 1) | CurrencyBR }}</strong></span>
        <span title="Unidade"><strong>{{ info.itemInfo.unity }}</strong></span>
      </div>
      <span class="description">{{ info.itemInfo.description }}</span>
    </div>

    <div class="product">
      <div
        class="notquoted"
        v-if="!(info.itemQuoted && info.itemQuoted.pativo)">
        <span class="label">NÃO COTADO</span>
      </div>

      <template v-if="info.itemQuoted && info.itemQuoted.pativo">
        <span class="pativo">{{ info.itemQuoted && info.itemQuoted.pativo }}</span>
        <span class="comercialname">{{ info.itemQuoted && info.itemQuoted.comercialName }}</span>
        <div class="lab">
          <span class="label">{{ info.itemQuoted && info.itemQuoted.lab }}</span>
        </div>
      </template>
    </div>

    <div class="price">
      <template v-if="info.itemQuoted && info.itemQuoted.pativo">
        <span class="cost"><small>R$</small> {{ info.itemQuoted && info.itemQuoted.cost | CurrencyBR }}</span>
        <span class="factor" v-if="info.itemInfo && info.itemInfo.factor > 1"><small>FATOR x </small> {{ info.itemInfo && info.itemInfo.factor }}</span>
        <span class="quantity">x {{ info.itemInfo.quantity | DecimalNumber}}</span>
        <span class="subtotal">
          <small>R$</small> 
          {{ info.itemInfo.quantity * (info.itemInfo.factor || 1) * (info.itemQuoted ? info.itemQuoted.cost : 0) | CurrencyBR }}
        </span>
      </template>
    </div>

  </li>
</template>

<script>
import { DecimalNumber, CurrencyBR } from '@/components/primitives/helpers/filters'
import { IconLockGliph } from '@/components/primitives/icons'

export default {
  name: 'ColumnItem',
  components: {
    IconLockGliph
  },
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  filters: {
    DecimalNumber,
    CurrencyBR
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-quote/components/column-item/ColumnItem.vue